import { useFeatureFlags } from "@/hooks/useFeatureFlags";
import { cn } from "@/lib/utils";
import { ClassAttributes, HTMLAttributes } from "react";

import { SideFooter } from "./Footer";
import { NavMenuTrial } from "./NavMenuTrial";

export const SideBarTrial = ({
    className,
    ...props
}: ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement>) => {
    const { isFeatureEnabled } = useFeatureFlags();

    return (
        <aside
            className={cn(
                `sticky left-0 top-[var(--header-height)]
                mr-[var(--sidebar-margin)] flex h-[calc(100vh-120px)]
                w-[var(--sidebar-width)] flex-col justify-between gap-6`,
                className
            )}
            {...props}
        >
            <NavMenuTrial showSubMenu />
            {isFeatureEnabled("UI_HEADER_DROPDOWN") && <SideFooter />}
        </aside>
    );
};
